<template>
  <section :class="['lifestories-listing', { '-is-loading': loading }]">
    <div class="l-wrapper">
      <ul>
        <li
          v-for="story in stories"
          :key="story.id"
          :data-slug="story.slug">
          <life-story-card
            v-bind="story"
            :kitchen="exists(story.kitchen) ? getFirst(story.kitchen) : null"
            :image="exists(story.images) ? getFirst(story.images) : null"
            :date="story.date ?? story.dateCreated" />
        </li>
      </ul>

      <div
        v-if="loadMore"
        class="lifestories-listing__loadmore">
        <cta
          :text="$t('actions.loadmore')"
          variant="text"
          color="red"
          @click="onLoadMore" />
      </div>
    </div>
  </section>
</template>

<script setup>
  import { useLifeStoriesStore } from '~/store/life-stories'

  const { bus } = useNuxtApp()
  const lifestories = useLifeStoriesStore()

  const loading = ref(false)

  const props = defineProps({
    stories: {
      type: Array
    }
  })

  const limit = computed(() => {
    return lifestories.limit
  })
  const loadMore = computed(() => {
    return lifestories.loadMore
  })

  const onLoadMore = async () => {
    loading.value = true
    lifestories.offset = lifestories.stories.length + 1
    await lifestories.getStories()
    loading.value = false
  }

  watch(() => props.stories, async _ => {
    await nextTick()
    bus.emit('scroll:refresh')
    bus.emit('scrolltrigger:refresh')
  }, { immediate: true })
</script>

<style lang="scss" scoped>
  .lifestories-listing {
    width: 100%;
    transition: opacity 0.3s;

    @include blocks-padding-bottom;

    &.-is-loading {
      opacity: 0.4;
    }

    ul {
      @include neutralize-list;

      display: grid;
      grid-template-columns: repeat(1, minmax(0, 1fr));
      gap: var(--grid-gutter);

      @include mq(tablet) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }

      @include mq(medium) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
      }
    }

    li {
      width: 100%;
      height: 100%;
    }

    &__loadmore {
      width: 100%;
      padding: rem(64px) 0 0;
      text-align: center;
    }
  }
</style>
